import { InteracEditEmailRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

// No Success-throw: the caller (PaymentMethodDetails.submitEditInterac) inspects
// the { Success, ErrorMessage } response itself, matching the portal contract.
export default function useEditInterac() {
  const api = useApi();

  const editInterac = async (requestParams: InteracEditEmailRequest) => {
    const response = await api.postEditInteracEmail(requestParams);

    return response;
  };

  return {
    editInterac,
  };
}
